import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ForgeSAHome from "./forgesa-home";
import Projects from "./Projects";
import About from "./About";
import Testimony from "./Testimony";
import HowItWorks from "./HowItWorks";
import Register from "./Register";
import Dashboard from "./Dashboard";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import ImpactCalculator from "./ImpactCalculator";
import Admin from "./Admin";
import { injectTheme } from "./theme";
import Community from "./Community";
import Suppliers from "./Suppliers";
import ResetPassword from "./ResetPassword";
import FAQ from "./FAQ";
import ThePlan from "./ThePlan";
import TheForge from "./TheForge";
import ForgeVault from "./ForgeVault";
import ProposeProject from "./ProposeProject";
import SubmitMilestone from "./SubmitMilestone";

injectTheme();

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ForgeSAHome />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/testimony" element={<Testimony />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/impact" element={<ImpactCalculator />} />
        <Route path="/community" element={<Community />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/plan" element={<ThePlan />} />
        <Route path="/the-forge" element={<TheForge />} />
        <Route path="/forge-vault" element={<ForgeVault />} />
        <Route path="/propose-project" element={<ProtectedRoute><ProposeProject /></ProtectedRoute>} />
        <Route path="/submit-milestone" element={<ProtectedRoute><SubmitMilestone /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;